exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-back[data-v-2be08f28]{display:flex;flex-direction:row;align-items:center;padding:6px 18px;border:1px solid #2f23d6;border-radius:4px!important;font-size:14px;font-weight:500;color:#2f23d6;cursor:pointer;transition:.2s;text-decoration:none}.btn-back[data-v-2be08f28]:hover{color:#fff;background:#2f23d6}.btn-back ion-icon[data-v-2be08f28]{font-size:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2be08f28","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/components/buttons/btnBack.vue
// module id = 701
// module chunks = 0